import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getEligibilityStatus, syncEligibility, updatePartnerAccounts } from './index';

export const createPartnersApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getEligibilityStatus: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getEligibilityStatus(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getEligibilityStatus', isInFlight);
    },
  ),
  syncEligibility: (instance: IPublicClientApplication, onProgress: (progress: number) => void) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => syncEligibility(fetchContext, onProgress, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('syncEligibility', isInFlight);
    },
  ),
  updatePartnerAccounts: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updatePartnerAccounts(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updatePartnerAccounts', isInFlight);
    },
  ),
});
